function obterUsuarioAtualStorage() {
  var usuario = localStorage.getItem("usuario-gb");

  if (usuario) {
    usuario = atob(usuario);
    return JSON.parse(usuario);
  }
  return undefined;
}

function salvarUsuarioNaStorage(usuario) {
  usuario = btoa(JSON.stringify(usuario));
  localStorage.setItem("usuario-gb", usuario);
}

function obterTokenNaStorage() {
  return localStorage.getItem("token-cp");
}

function salvarTokenNaStorage(token) {
  localStorage.setItem("token-cp", token);
}

function removerAutenticacao() {
  localStorage.removeItem("token-cp");
}

export default {
  obterUsuarioAtualStorage,
  salvarUsuarioNaStorage,
  obterTokenNaStorage,
  salvarTokenNaStorage,
  removerAutenticacao,
};
